import styled from "styled-components";

export const LayoutContainer = styled.div`
    min-height: calc(100vh - 400px);
    @media (max-width: 999px) {
        min-height: calc(100vh - 439px);
    }
    @media (max-width: 599px) {
        min-height: calc(100vh - 322px);
    }
`

export const ZigZagBottom = styled.section`
  background-color: #0a265a;
  color: white;
  padding: 40px;
  margin-top: 70px;
  clip-path: polygon(
    0% 100px,
    15% 100px,
    85% 0px,
    100% 0px,
    100% 100%,
    0% 100%
  );
  font-size: 14px;

  @media (max-width: 999px) {
    padding-top: 60px;
    }

    @media (max-width: 599px) {
    padding: 12px 18px;
    padding-top: 40px;
        clip-path: polygon(
        0% 50px,
        15% 50px,
        85% 0px,
        100% 0px,
        100% 100%,
        0% 100%
    );
        font-size: 10px;
    }
`;

export const FooterContainer = styled.footer`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    @media (max-width: 599px) {
        gap: 60px;
    }
`;

export const FooterLogo = styled.img`
    width: 36px;
    height: 36px;

    @media (max-width: 599px) {
        width: 28px;
        height: 28px;

    }
`;

export const FooterAddress = styled.div`
    width: 400px;
`;

export const FooterAddressHeading = styled.h3`
`;

export const FooterAddressContent = styled.p`
`;

